import LightsManager from './Manager';

export default LightsManager;
